
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reference/values/column-values",
      function () {
        return require("private-next-pages/reference/values/column-values.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reference/values/column-values"])
      });
    }
  